/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { getEnvironment } from 'src/core/utils/api/environment';

interface StorageBlobEndpointParams {
    storageAccountName: string;
    containerName?: string;
    blobName?: string;
    query?: string;
}
// constructs the endpoint for the storage blob
export const getStorageUrl = ({ storageAccountName, containerName, blobName, query }: StorageBlobEndpointParams): string => {
    let suffix = getEnvironment().storageBlobSuffix;
    if (!suffix) {
        suffix = 'blob.core.windows.net';
    }
    const endpoint = `https://${storageAccountName}.${suffix}/${containerName ?? ''}${blobName ? `/${blobName}` : ''}${
        query ? `?${query}` : ''
    }`;
    return endpoint;
};
